import Device from '../../../devices/device';
import AbstractRequestTask from "../AbstractRequestTask";
import EpgPersistence from "../../../AAF/Nepg/EpgPersistence";
import { DOMAIN } from "./const";

class playbackTask extends AbstractRequestTask{
    constructor(leagueId, matchId, miniplayerRetryConfig, version = 'v1', acceptLanguage = "es-ES", playComments = true, key_akt_seed = null) {
        super();
        const device_config = Device.getDevice().getConfig();
        this.leagueId = leagueId;
        this.matchId = matchId;
        this.miniplayerRetryConfig = miniplayerRetryConfig;
        this.acceptLanguage = acceptLanguage;
        this.version = version;
        this.streamType = device_config && device_config.stream_type ? device_config.stream_type : 'smooth_streaming';
        this.params = super.getParams();
        this.user_token = this.params.user_token;
        this.playComments = playComments;
        this.key_akt_seed = key_akt_seed;
        console.log('oscar playbackTask params', key_akt_seed);
    }

    getUrl() {
        const http = "https://";
        const domain = DOMAIN;
        const path = `/services/sports/${this.version}/competitions/${this.leagueId}/matches/${this.matchId}/playback`;
                      
        return `${http}${domain}${path}`;
    }

    getParams() {
        const params = super.getParams();
        delete params.format;
        delete params.api_version;
        delete params.user_token;
        if((this.version === 'v2' || this.version === 'v3') && this.playComments) {
            params.playComments = this.playComments;
        }
        
        params.streamType = this.streamType;

        (this.key_akt_seed) && (params.key_akt_seed = this.key_akt_seed);

        return {
            ...params,
            timezoneOffset: EpgPersistence.getOffset() / 60
        };
    }

    getHeaders() {
        return {
            'Authorization': `Bearer ${this.user_token}`,
            'Accept-Language': this.acceptLanguage
        }
    }

    getRetriesNumber() {
        return this.miniplayerRetryConfig && this.miniplayerRetryConfig.attempts ? this.miniplayerRetryConfig.attempts : 0;
    }

    getMethod() {
        return 'GET';
    }
}

export default playbackTask;


// WEBPACK FOOTER //
// ./src/requests/tasks/sports/playbackTask.js